module.exports = __webpack_public_path__ + "img/contract-add.13d36168.svg";